import {HttpParams} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable, of, switchMap} from 'rxjs';
import {catchError, first, retry} from 'rxjs/operators';
import {WorkflowService} from '../workflows/workflow-service.service';
import {GoogleAnalyticsService} from 'ngx-google-analytics';

@Component({
    selector: 'app-root',
    template: `
    <div class="d-flex mt-4 mx-n4 pb-4 h-100" *ngIf="this.batchStatusResponse | async as response; else loading">
      <nav class="col col-lg-3 col-sm-4 col-md-3 bg-secondary sidebar h-100 rounded-start">
        <ul class="nav nav-tabs border-0 flex-column my-3 mx-2"><h4>Batches</h4>
          <ng-container *ngIf="response.count > 0">
            <li class="nav-item text-nowrap w-100" role="presentation" *ngFor="let val of response.items; let i = index">
              <button class="nav-link d-flex text-start border-0 w-100" id="category-{{val.file_name}}" type="button" role="tab" aria-selected="true"
                      (click)="this.selectBatchIndex(i)" [class.active]="i === this.selectedBatchIndex">
                <span class="mdi mdi-file-document-outline text-truncate w-100"> {{ val.file_name }}</span></button>
            </li>
          </ng-container>
        </ul>
      </nav>
      <ng-container>
        <div class="col col-lg-9 col-sm-8 col-md-9 mb-3 h-100">
          <div class="card h-100">
            <div class="card-body">
              <div *ngIf="error_message" class="row mb-2">
                <div class="col-12 mb-3 h-100">
                  <div class="alert alert-danger" role="alert">
                    <h4 class="alert-heading">{{error_message}}</h4>
                    <hr>
                    <p class="mb-0">If the error persists please contact us at <a class="text-danger"
                                                                                  href="mailto:{{support_email}}">{{support_email}}</a>.</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <table class="table table-hover table-sm table-centered mb-0">
                      <thead>
                      <tr>
                        <th>Policy Number</th>
                        <th *ngIf="custom_column_name">{{this.custom_column_name}}</th>
                        <th>Product Code</th>
                        <th>Effective Date</th>
                        <th>Expiration Date</th>
                        <th>Status</th>
                        <th>Edit</th>
                      </tr>
                      </thead>
                      <tbody>
                      <ng-container *ngIf="response.count > 0">
                      <tr *ngFor="let record of response.items[this.selectedBatchIndex].records | slice: (this.page - 1) * this.pageSize : this.page * this.pageSize">
                        <td class="text-truncate mxw-10vw">
                          {{ record.policy_number }}
                        </td>
                        <td class="text-truncate mxw-10vw" *ngIf="custom_column_name">
                          {{ record.custom_column }}
                        </td>
                        <td class="text-truncate mxw-10vw">
                          {{ record.product_code }}
                        </td>
                        <td class="text-truncate mxw-10vw">
                          {{ record.effective_date | date:'M/d/y' }}
                        </td>
                        <td class="text-truncate mxw-10vw">
                          {{ record.expiration_date | date:'M/d/y' }}
                        </td>
                        <td class="text-truncate mxw-10vw">
                          <span class="badge rounded-pill" [ngClass]="{
                          'bg-success': record.status === this.WorkflowStatus.RETRY_READY,
                          'bg-warning': record.status === this.WorkflowStatus.CLOSED,
                          'bg-danger': record.status === this.WorkflowStatus.FAILED
                          }">
                            {{ record.status }}
                          </span>
                        </td>
                        <td class="table-action">
                          <a href="javascript: void(0);" (click)="this.selectRow(record)" class="action-icon" data-bs-toggle="modal"
                             data-bs-target="#modal"><i class="mdi mdi-pencil"></i></a>
                        </td>
                      </tr>
                      </ng-container>
                      <ng-container *ngIf="response.count === 0">
                        <tr>
                          <td class="text-truncate mxw-10vw">
                            -
                          </td>
                          <td class="text-truncate mxw-10vw">
                            -
                          </td>
                          <td class="text-truncate mxw-10vw" *ngIf="custom_column_name">
                            -
                          </td>
                          <td class="text-truncate mxw-10vw">
                            -
                          </td>
                          <td class="text-truncate mxw-10vw">
                            -
                          </td>
                          <td class="text-truncate mxw-10vw">
                            -
                          </td>
                          <td class="table-action">
                            -
                          </td>
                        </tr>
                      </ng-container>
                      </tbody>
                  </table>
                  <div class="mt-3 d-flex justify-content-center">
                    <ngb-pagination [collectionSize]="response.items[selectedBatchIndex]?.records?.length ?? 0" [(page)]="page" [pageSize]="pageSize" class="d-flex justify-content-center"></ngb-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-template #loading>
      <div class="row d-flex flex-center content-min-h">
        <app-loading-indicator class="col" loading_text="Loading batches..." [is_loading]="true"></app-loading-indicator>
      </div>
    </ng-template>

    <div id="modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center mt-2 mb-4">
              <h3>Update Status</h3>
            </div>
            <form class="ps-3 pe-3">
              <div class="mb-3">
                <select class="form-select" name="updatedStatus" [(ngModel)]="this.targetPolicyUpdatedStatus">
                  <option [value]="this.WorkflowStatus.RETRY_READY" selected>{{this.WorkflowStatus.RETRY_READY}}</option>
                  <option [value]="this.WorkflowStatus.CLOSED">{{this.WorkflowStatus.CLOSED}}</option>
                </select>
              </div>
              <div class="mb-3 float-end">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                <button class="btn btn-primary mx-1" type="button"  data-bs-dismiss="modal"
                        [disabled]="this.targetPolicyStatusSaving" (click)="this.saveStatus()">
                  <span *ngIf="this.targetPolicyStatusSaving else notLoading">
                      <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      Submitting...
                    </span>
                  <ng-template #notLoading>Submit Mapping</ng-template>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  `,
    styles: `
    .nav-item:hover .nav-link, .nav-link.active {
      color: #ffffff !important;
      background-color: transparent;
    }

    .nav-link, .nav {
      color: #cedce4 !important;
    }

    .mxw-10vw {
      max-width: 10vw;
    }
  `,
    standalone: false
})
export class BatchStatusComponent implements OnInit {
  protected portalId: string | undefined;
  protected dmLibrary: string | undefined;
  public error_message: string;
  public custom_column_name = '';
  public readonly support_email = 'Support@DarkMatterIns.com';
  protected batchStatusResponse: Observable<BatchStatusResponse> = new Observable<BatchStatusResponse>();
  protected selectedBatchIndex = 0;

  protected page = 1;
  protected pageSize = 50;

  protected readonly WorkflowStatus = WorkflowStatus;

  protected targetPolicy?: PolicyImportStatus;
  protected targetPolicyUpdatedStatus: WorkflowStatus = WorkflowStatus.RETRY_READY;
  protected targetPolicyStatusSaving = false;

  constructor(private workflowService: WorkflowService, private route: ActivatedRoute, private googleAnalytics: GoogleAnalyticsService) {}

  ngOnInit(): void {
    this.portalId = this.route.snapshot.queryParamMap.get('portal_id');
    this.dmLibrary = this.route.snapshot.queryParamMap.get('dm_library');
    this.batchStatusResponse = this.loadBatchStatus();
  }

  protected selectBatchIndex(index: number): void {
    this.googleAnalytics.event('clicked_batch_category', 'update_status', 'Clicked Batch Category');
    this.selectedBatchIndex = index;
    this.page = 1;
  }

  protected selectRow(record: PolicyImportStatus): void {
    this.googleAnalytics.event('clicked_edit', 'update_status', 'Clicked Batch Item Edit Button');
    if (record.status === WorkflowStatus.CLOSED) {
      this.targetPolicyUpdatedStatus = WorkflowStatus.CLOSED;
    } else {
      this.targetPolicyUpdatedStatus = WorkflowStatus.RETRY_READY;
    }
    this.targetPolicy = record;
  }

  protected saveStatus(): void {
    this.googleAnalytics.event('clicked_save', 'status_update', 'Clicked Save Changes Button');
    if (!this.targetPolicy) {
      this.targetPolicyStatusSaving = true;
      return;
    }

    const params = new HttpParams().set('portal_id', this.portalId).set('dm_library', this.dmLibrary);
    const options = {
      uniqueness: this.targetPolicy.uniqueness,
      batch_name: this.targetPolicy.batch_name,
      status: this.targetPolicyUpdatedStatus,
      params
    };
    this.workflowService.execute('status_update', options, 'workflow/', 'POST').pipe(first(), retry(3),
      catchError((response) => { this.error_message = response.output.error.message; return null; })).subscribe((response: any) => {
        console.log(response.output);
        if (response.output.success) {
          this.targetPolicy.status = this.targetPolicyUpdatedStatus;
        } else {
          this.error_message = response.output.error.message;
        }
        return of(true);
      });
  }

  private loadBatchStatus(): Observable<BatchStatusResponse> {
    this.page = 1;
    this.selectedBatchIndex = 0;

    const params = new HttpParams().set('lookup_type', 'update_status').set('portal_id', this.portalId).set('dm_library', this.dmLibrary);
    const options = { headers: { 'Cache-Control': 'no-cache' }, params };
    return this.workflowService.execute('lookup', options, 'ams/', 'GET').pipe(
      first(),
      switchMap(response => {
        const output = response.output;
        const statusResponse: BatchStatusResponse = { items: [], count: 0 };

        if (response.success && output.items?.length) {
          const grouped_items: Record<string, PolicyImportStatus[]> = {};
          this.error_message = '';

          for (const item of output.items) {
            const batch_name = item.batch_name;
            if (!grouped_items[batch_name]) {
              grouped_items[batch_name] = [];
            }
            if (!this.custom_column_name && item.custom_column_name) {
              this.custom_column_name = item.custom_column_name;
            }

            grouped_items[batch_name].push({
              ...item,
              effective_date: item.effective_date.split('T')[0],
              expiration_date: item.expiration_date.split('T')[0],
            });
          }

          statusResponse.items = Object.entries(grouped_items).map(([file_name, records]) => ({
            file_name,
            records
          }));

          statusResponse.count = statusResponse.items.length;
        } else if (!response.success) {
          this.error_message = output.error.message;
        }

        return of(statusResponse);
      })
    );
  }
}

interface BatchStatusResponse {
  items: BatchItem[];
  count: number;
}

interface BatchItem {
  file_name: string;
  records: PolicyImportStatus[];
}

interface PolicyImportStatus {
  batch_name: string;
  uniqueness: string;
  custom_column: string;
  custom_column_name: string;
  policy_number: string;
  product_code: string;
  effective_date: string;
  expiration_date: string;
  status: WorkflowStatus;
}

enum WorkflowStatus {
  RETRY_READY = 'RETRY_READY',
  CLOSED = 'CLOSED',
  FAILED = 'FAILED'
}
